// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_3uN27","image":"ECDxf","credits":"_14R4O"};